import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/reset.css';
import './styles/design-tokens.css';
import './styles/animations.css';
import './index.css';
import App from './App.tsx';

// Performance monitoring is handled by the Vite plugin during build
// No need to initialize in browser runtime

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>
);
